import {
  type SkipToken,
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import type { JobApi, JobsFilterParamsApi } from '@/modules/jobs/types';

import { jobsQueryKeys } from './queryKeys';

const ALL_JOBS_QUERY_LIMIT = 500;

/** Pass `skipToken` as `params` to skip the read. */
export const useJobsQuery = (
  params?: JobsFilterParamsApi | SkipToken,
  options?: Omit<
    UseQueryOptions<JobApi[] | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: jobsQueryKeys.list(params === skipToken ? undefined : params),
    queryFn:
      params === skipToken
        ? skipToken
        : async () => {
            const { data } = await fetchClient.GET(endpoints.jobs, {
              params: {
                query: {
                  ...params,
                  limit: ALL_JOBS_QUERY_LIMIT,
                },
              },
            });

            return data?.items;
          },
    ...options,
  });
};
